import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    standalone: false,
    selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  authCode: string = 'fe61707a3283cff6a586e8a7094a660d';
  authCompId: string = 'orbitaxbdltd';
  authAction: string = 'accept';
  constructor(private router: Router) { }

  ngOnInit() {
  }
  navigateToPreference() {
    this.router.navigate(['/UpdatePreference'], { queryParams: { code: this.authCode } });
  }
  navigateToContact() {
    this.router.navigate(['/ContactRequest'], { queryParams: { code: this.authCode, companyindex: this.authCompId, actiontype: this.authAction } });
  }
  toggle() {

  }
}
